<template>
    <div class="download-nametag-container">
        <div class="d-flex justify-content-start flex-column w-100 mb-3">
            <h1 class="header mb-2">Download and follow instructions in the Nametag app</h1>
            <p class="sub-header mb-0">Autodesk uses Nametag to verify your identity. Download it from your app store or Google Play on your phone and proceed to next step.
            </p>
        </div>

        <div class="image-container w-100 text-start d-flex flex-row justify-content-between flex-nowrap">
            <div class="qr-code-wrapper text-start d-flex flex-row align-items-center justify-content-center flex-wrap">
                <a href="https://apps.apple.com/zw/app/nametag-sign-in-with-id/id1546248921" target="_blank"><img
                        class="app_store_image" src="../assets/images/app_store.png" alt="Apple Store Image" /></a>
                <img class="desktop-view" src="../assets/images/qr_code_apple_app_store.png"
                    alt="Download Nametag Iphone" />
            </div>
            <div></div>
            <div
                class="qr-code-wrapper google-store-wrapper border-none border-lg-1 text-start d-flex flex-row align-items-center justify-content-center flex-wrap ml-0 ml-lg-4 pl-lg-4">
                <a href="https://play.google.com/store/apps/details?id=nametag.hello" target="_blank"><img
                        class="app_store_image" src="../assets/images/google_playstore.png"
                        alt="Goggle Play Store Image" /></a>
                <img class="desktop-view" src="../assets/images/qr_code_google_play_store.png"
                    alt="Download Nametag Android" />
            </div>
        </div>

        <div class="d-flex justify-content-end w-100 button-container error-message-container">
            <div class="button-container">
                <button class="btn flat-btn blue-btn cancel-button ml-3 cursor-pointer p-0" @click="cancelStep">Cancel</button>
                <button class="btn flat-btn primary-blue-btn next-button ml-3 cursor-pointer p-0"
                    @click="nextStep">Next</button>
            </div>
        </div>
        <loading-overlay v-if="isLoading"></loading-overlay>
    </div>
</template>

<script>
import LoadingOverlay from '@/components/LoadingOverlay.vue';

export default {
    name: "DownloadNametagApp",
    components: {
        LoadingOverlay
    },
    data() {
        return {
            isLoading: false,
            errorMessage: ''
        }
    },
    methods: {
        showManualVerification() {
            this.$emit("showManualVerification");
        },
        cancelStep() {
            document.title = 'Enterprise Search';
            this.$router.push('/');
        },
        nextStep() {
            this.isLoading = true;
            setTimeout(() => {
                this.$emit("nextStep", 2);
                this.isLoading = false;
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 3000)
        }
    }
};
</script>

<style scoped>
.download-nametag-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: auto;
    max-width: 1200px;
    color: black;
    font-family: artifaktElementRegular;
    padding: 0px 10px;
    margin-top: 20px;
}

.header {
    font-size: 20px;
    font-weight: bolder;
    color: black;
    font-family: sans-serif;
    margin: 20px 0px;
}

.identity-failure-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
    padding: 5px 10px;
    justify-content: flex-start;
    width: 100%;
    font-size: 14px;
    border: 1px solid #CC4B24;
    background-color: #FAEDE9;
}

.identity-validation {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
}

.cancel-button:hover {
    background-color: transparent !important;
    color: inherit !important;
}

.sub-header {
    font-size: 15px;
    width: 85%;
}

.checkbox-container {
    margin: 10px 0px;
}

.custom-checkbox {
    width: 18px;
    height: 17px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    position: relative;
    margin-right: 8px;
    cursor: pointer;
    margin-top: 4px;
}

.desktop-view {
    display: flex !important;
}

.custom-checkbox:checked::before {
    content: '\2714';
    font-size: smaller;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 17px;
    height: 17px;
    background-color: #5f60ff;
    border-radius: 2px;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
}

.checkbox-label {
    font-size: 14px;
    width: 90%;
}

.link {
    color: #000000 !important;
    word-break: break-all;
    text-decoration: underline;
}

.image-container {
    margin-top: 20px;
    margin-bottom: 20px;
}

.image-container img {
    width: 150px;
    height: 150px;
    margin-right: 20px;
    margin-top: 20px;
}

.app_store_image {
    width: 130px !important;
    height: 40px !important;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.button-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.button {
    padding: 6px 40px;
    border-radius: 40px;
    font-weight: 700;
    font-size: 14px;
    width: 130px;
    height: 36px;
}

.qr-code-wrapper {
    width: 48%;
    border: 1px solid gray;
    padding: 40px;
    border-radius: 6px;
}

.cancel-button {
    background-color: white;
    min-width: 80px !important;
    height: 40px;
    text-transform: capitalize;
    border-radius: 4px !important;
    max-width: 190px;
}

.next-button {
    text-transform: capitalize;
    min-width: 80px !important;
    height: 40px;
    color: white;
    border: none;
    border-radius: 4px !important;
    max-width: 190px;
}

.btn:disabled {
    opacity: 0.35 !important;
}

.next-button:hover:not(:disabled) {
    background-color: #5a52d1;
}

.next-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.error-message {
    color: red;
    font-size: 14px;
}

@media ((min-width: 700px) and (max-width: 900px)) {
    .qr-code-wrapper {
        flex-direction: column !important;
    }

    .google-store-wrapper {
        margin-left: 30px !important;
        padding-left: 50px !important;
    }
}

@media (max-width: 700px) {
    .download-nametag-container {
        margin-top: 0px !important;
        padding: 0px;
    }

    .header {
        font-size: 18px;
    }

    .sub-header {
        width: 100%;
        margin-top: 10px;
    }

    .identity-failure-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

    .custom-label {
        margin-left: 40px;
        margin-bottom: 100px;
        margin-top: -56px;
    }

    .custom-checkbox {
        width: 20px;
    }

    .button-container {
        padding-right: 0px !important;
        width: 100%;
        align-items: center !important;
        justify-content: center !important;
    }

    .image-container {
        margin-top: 0px;
        margin-bottom: 0px;
        padding: 0px;
        padding-bottom: 10px;
        flex-direction: column !important;
        justify-content: center !important;
        flex-wrap: wrap !important;
    }

    .google-store-wrapper {
        border: 0px;
    }

    .error-message-container {
        flex-direction: column;
    }

    .cancel-button {
        margin-left: 0px !important;
    }

    .qr-code-wrapper {
        width: 100%;
        border: none;
        padding: 4px;
        justify-content: flex-start !important;
    }

    .app_store_image {
        width: 180px !important;
        height: 54px !important;
        margin-bottom: 16px !important;
    }

    .image-container img {
        width: 100%;
        margin: 0px;
        max-width: 200px;
        border: 1px solid gray;
        border-radius: 10px;
    }

    .error-message {
        margin-top: 0px !important;
    }

    .desktop-view {
        display: none !important;
        margin-top: 20px !important;
        margin-left: 20px !important;
    }
}
</style>